import React from 'react';
import { Collapse } from 'reactstrap';
import './EnterpriseActions.css';

class CollapseControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapse: false };
  }
  
  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  }

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  }
   
  render() {
    const { description } = this.props;
    return (
      <div>
          <span onClick={this.toggle}  className="showDescription">Description<span className="flaticon-down-arrow"></span></span>
            <div className="word-break single_objectives_view_description_text">
              <Collapse className="mt10" isOpen={this.state.collapse} dangerouslySetInnerHTML={this.createMarkup(description)}></Collapse>
            </div>
      </div>
    );
  }
}

export default CollapseControl;